import clsx from "clsx";
import Button from "../../../ui/molecules/button";
import { XCircleIcon } from "../../../ui/icons/xCircle";
import { colors } from "../../../ui/colors";

interface Props {
  visible: boolean;
  onClose: () => void;
  projects?: string[];
  targets?: string[];
}

export function CantDeleteModal({
  visible,
  onClose,
  projects = [],
  targets = []
}: Props) {

    return (
        <div
            onClick={onClose}
            className={clsx(
                "transition-all fixed bg-opacity-30 bg-neutral-950 backdrop-blur-sm top-0 left-0 h-full w-full flex items-center justify-center z-[100]",
                {
                    block: visible,
                    hidden: !visible,
                }
            )}
        >
            <div
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                className="transition-all max-w-[30%] flex flex-col items-center gap-5 p-[20px] bg-white rounded-[12px] opacity-100 shadow-sm min-w-[400px]"
            >
                <XCircleIcon color={colors.red[500]} size={64} />
                <span className="text-heading-xs text-neutral-800 font-bold">
                    {"Impossibile eliminare l'utente"}
                </span>
                <span className="text-text-md font-normal text-center text-neutral-600">
                    {"Non è stato possibile eliminare l'utente perché associato  "}
                    {projects.length > 0 ? ' ai seguenti progetti: ' : ' alle seguenti liste target: '}
                    {projects.map((project, index) => (project + (index === projects.length - 1 ? '' : ', ')))}
                    {targets.map((target, index) => (target + (index === targets.length - 1 ? '' : ', ')))}
                    .
                </span>
                <div className="w-full flex items-center justify-center flex-1 gap-3">
                    <Button
                        size={"md"}
                        iconPosition={"off"}
                        variant={"solid"}
                        color={"red"}
                        label="Chiudi"
                        onClick={onClose}
                    />
                </div>
            </div>
        </div>
    );
}
